import { useMutation } from '@tanstack/react-query';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';
import { WorkspaceProperties } from '../systems/WorkspaceSystem';

type UseUpdateWorkspaceMutationParams = {
	workspaceID: number;
	onSuccess?: () => void;
	onError?: ( error: unknown ) => void;
};

const useUpdateWorkspaceMutation = ( { workspaceID, onSuccess, onError }: UseUpdateWorkspaceMutationParams ) => {
	const system = useWorkspaceSystem();

	return useMutation(
		async ( properties: Partial<WorkspaceProperties> ) => system.updateWorkspace( {
			workspaceID, properties
		} ),
		{ onSuccess, onError }
	);
};

export default useUpdateWorkspaceMutation;
